<template>
	<div>
		<!-- 检索条件 -->
		<div>
			<el-form :inline="true" @submit.native.prevent>
				<el-row>
					<el-form-item label="供应商">
						<el-input style="width:200px" placeholder="'请输入供应商" v-model.trim="queryMap.smName" clearable
							size="mini">
						</el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" size="mini" @click="searchData">查询</el-button>
					</el-form-item>
				</el-row>
			</el-form>
		</div>
		<!-- 表格 -->
		<el-table ref="moviesTable" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent"
			@selection-change="handleSelectionChange" height="360" size="mini" style="width: 100%"
			:data="settleDataList" border>
			<el-table-column v-for="(item,index) in settleList" :key="index" align="center" min-width="140"
				:prop="item.props" :label="item.label" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="item.props == 'dpsmDate'">
						<span>{{$common.getLocalTime(scope.row[item.props])}}</span>
					</div>
					<div v-else-if="item.props == 'createTime'">
						<span>{{$common.getLocalTime(scope.row[item.props],true)}}</span>
					</div>
					<div v-else-if="item.props == 'settleMode'">
						<el-tag size="mini">
							{{scope.row.settleMode == 0 ? '按单据' : '按明细'}}</el-tag>
					</div>
					<div v-else-if="item.props == 'dpsmState'">
						<div v-for="(x,y) in stateList" :key="y">
							<el-tag size="mini" v-if="x.key == scope.row.dpsmState">{{x.value}}</el-tag>
						</div>
					</div>
					<!-- 库房 -->
					<span v-else>{{settleDataList[scope.$index][item.props]}}</span>
				</template>
			</el-table-column>
			<el-table-column v-if="!isDetail" fixed="right" label="操作" width="110" align="center">
				<template slot-scope="scope">
					<el-button size="mini" type="text" @click.stop="handleSelectClick(scope.row)">确认选择</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
			:page-sizes="pageSizes" background :page-size="pageSize" layout="total, sizes, prev, pager, next"
			:total="total">
		</el-pagination>
		<div style="margin: 10px 0;">
			<el-tag v-if="tableType == 0">单据表格</el-tag>
			<el-tag v-if="tableType == 1">明细表格</el-tag>
		</div>
		<!-- 明细表(按单据) -->
		<el-table v-if="tableType == 0" size="mini" height="200" :data="detailDataBill" border stripe
			highlight-current-row :header-cell-style="getHeaderCellStyleD" style="width: 100%">
			<el-table-column v-for="(item,index) in settleBills" :key="index" align="center" min-width="140"
				:prop="item.props" :label="item.label" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="item.props == 'dpsmDate'">
						<div>
                            {{ $common.getLocalTime(scope.row[item.props]) }}
						</div>
					</div>
					<div v-else-if="item.props == 'createTime'">
						<div>
							{{$common.getLocalTime(scope.row[item.props])}}
						</div>
					</div>
					<span v-else>{{detailDataBill[scope.$index][item.props]}}</span>
				</template>
			</el-table-column>
		</el-table>
		<!-- 明细表(按明细) -->
		<el-table v-if="tableType == 1" size="mini" height="280" :data="detailDataMx" border stripe
			highlight-current-row :header-cell-style="getHeaderCellStyleD" style="width: 100%">
			<el-table-column v-for="(item,index) in settleDetails" :key="index" align="center" min-width="140"
				:prop="item.props" :label="item.label" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="item.props == 'dpsmDate'">
						<div>
                            {{ $common.getLocalTime(scope.row[item.props]) }}
						</div>
					</div>
					<div v-else-if="item.props == 'createTime'">
						<div>
							{{$common.getLocalTime(scope.row[item.props])}}
						</div>
					</div>
					<span v-else>{{detailDataMx[scope.$index][item.props]}}</span>
				</template>
			</el-table-column>
		</el-table>
		<!-- </el-collapse-item>
    </el-collapse> -->
	</div>
</template>
<script>
	export default {
		name: "ExtractionSchemePsSettle",
		components: {},
		data() {
			return {
				opmId: "",
				ormId: "",
				detailsub: true,
				activeName: "1",
				showdetail: false,
				detailData: [],
				currentPage: 1,
				pageSizes: [10, 25, 50, 100],
				pageSize: 10,
				total: 0,
				settleDataList: [],
				isPagination: "",
				queryMap: {
					page: 1,
					rows: 30,
					smName: ''
				},
				detailDataMx: [],
				detailDataBill: [],
				tableType: 0,
				searchTermList: [], //检索条件
				Columns: [],
				ColumnsDetail: [],
				isDetail: false,
				multipleSelection: [], //数组内层
				objList: [], //外层数组
				stateList: [{
						"key": 0,
						"value": "初始"
					},
					{
						"key": 1,
						"value": "审核退回"
					},
					{
						"key": 2,
						"value": "提交审核"
					},
					{
						"key": 3,
						"value": "审核通过"
					},
					{
						"key": 4,
						"value": "已记账"
					}
				],
				settleList: [{
						props: 'applyType',
						label: '单据类型'
					},
					{
						props: 'dpsmId',
						label: '单据编号'
					},
					// {
					//     props: 'dpsmDate',
					//     label: '申请日期'
					// },
					{
						props: 'smName',
						label: '供应商'
					},
					{
						props: 'coName',
						label: '货主'
					},
					{
						props: 'opmName',
						label: '业务员'
					},
					{
						props: 'salesName',
						label: '对方业务员'
					},
					{
						props: 'createTime',
						label: '创建时间'
					},
					{
						props: 'dpsmRemark',
						label: '备注'
					},
					{
						props: 'settleMode',
						label: '结算方式'
					},
					{
						props: 'sbiAddress',
						label: '银行地址'
					},
					{
						props: 'sbiNumber',
						label: '银行账号'
					},
					{
						props: 'sbiName',
						label: '公司银行'
					},
				],
				settleDataList: [],
				settleBills: [{
						props: 'businessId',
						label: '业务单号'
					},
					{
						props: 'businessType',
						label: '业务类型'
					},
					{
						props: 'totalMoney',
						label: '总金额'
					},
					{
						props: 'settlementMoney',
						label: '已结算金额'
					},
					{
						props: 'oldBalance',
						label: '上期余额'
					},
					{
						props: 'settleMoney',
						label: '付款金额'
					}
				],
				settleDetails: [{
						props: 'bgmName',
						label: '通用名称'
					},
					{
						props: 'spec',
						label: '规格'
					},
					{
						props: 'manufacturer',
						label: '生产厂商'
					},
					{
						props: 'placeorigin',
						label: '产地'
					},
					{
						props: 'psprice',
						label: '含税价格'
					},
					{
						props: 'psmoney',
						label: '含税金额'
					},
					{
						props: 'settleCount',
						label: '结算数量'
					},
					{
						props: 'settleMoney',
						label: '结算金额'
					}
				],
				selectedRow: [], // 当前已选择行
				selectedIndex: 0, // 当前选择行的index
			};
		},
		watch: {},
		computed: {},
		mounted() {
			addEventListener('keyup', this.keyUpChild)
		},
		beforeDestroy() {
			removeEventListener('keyup', this.keyUpChild)
		},
		created() {
			this.getSettleList()
			this.$emit("getWidth", '95');
			this.$emit("sendTitle", '提取采购结算申请单');
		},
		methods: {
			async getSettleList() {
				var responseData = await this.$http.getPsSettlementExtractList(this.queryMap)
				if (responseData.status == 200) {
					this.settleDataList = responseData.result.list
					this.total = this.settleDataList.length;
					if (this.settleDataList[0].settleMode == 0) {
						this.tableType = 0
						this.detailDataBill = this.settleDataList[0].psSettlerInvoice
					} else if (this.settleDataList[0].settleMode == 1) {
						this.tableType = 1
						this.detailDataMx = this.settleDataList[0].psSettleInvoiceDetail
					}
					this.$nextTick(() => {
						if (!this.settleDataList) return
						let refsElTable = this.$refs.moviesTable
						refsElTable.clearSelection();
						refsElTable.toggleRowSelection(this.settleDataList[this.selectedIndex]);
					})
				} else {
					this.$message({
						message: responseData.message,
						type: 'error'
					});
				}
				this.$refs.moviesTable.doLayout();
			},
			// 双击主表格确认
			async handleSelectClick(row) {
				console.log(row)
				// 是否可选择明细
				// if (this.isDetail) {
				//   return this.$message.error("请选择明细");
				// }
				// if (this.settleDataList && this.settleDataList.length) {
				//   let queryMap = {
				//     id: row[this.ppId],
				//     extractId: this.id,
				//   };
				//   await this.getTableDetailList(queryMap);
				// }
				if (row.settleMode == 0) {
					row.arrlistbychen = row.invoiceVos
					this.$emit("TranData", row);
				} else {
					row.arrlistbychen = row.detailVos;
					this.$emit("TranData", row);
				}

			},
			// 勾选明细
			handleSelectionChange(val) {
				this.multipleSelection = val;
				if (val.length) {
					this.detailsub = false;
				} else {
					this.detailsub = true;
				}
			},
			// sureDetail() {
			//   this.objList.arrlistbychen = this.multipleSelection;
			//   this.$emit("TranData", this.objList);
			// },
			// 单击表格
			handleClick(row) {
				//   this.objList = row;
				if (row.settleMode == 0) {
					this.tableType = 0
					//   this.detailDataBill = row.psSettlerInvoice
					this.detailDataBill = row.invoiceVos
				} else if (row.settleMode == 1) {
					this.tableType = 1
					//   this.detailDataMx = row.psSettleInvoiceDetail
					this.detailDataMx = row.detailVos
				}
			},
			// 检索条件赋值
			handleChange(value, name) {
				// value默认参，name当前所需的name
				this.queryMap[name] = value;
			},
			//   查询
			searchData() {
				this.currentPage = 1;
				this.queryMap.page = 1;
				this.getSettleList();
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.queryMap.rows = val;
				this.getSettleList();
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.queryMap.page = val;
				this.getSettleList();
			},
			//   -----------------------------------------------------
			getHeaderCellStyle() {
				return "background: skybule; borderBottom: solid 1px #5a5e66;color: #3e5569";
			},
			getHeaderCellStyleD() {
				return "background: skybule;color: #3e5569";
			},
			keyUpChild(e) {
				// 表格为空，不执行下方 
				if (!this.settleDataList) return
				e.preventDefault();
				if (e.keyCode == 40) { // 下键
					e.preventDefault();
					let refsElTable = this.$refs.moviesTable
					this.$nextTick(() => {
						if (this.selectedRow.length == 0) { // 如果当前没有选中行，则直接选中第一个
							this.selectedIndex = 0
						} else if (this.selectedIndex == this.settleDataList.length -
							1) { // 如果选中的是最后一行了，那么下一行选中的是第一行
							this.selectedIndex = 0
						} else { // 正常递增
							this.selectedIndex++
						}
						if (!refsElTable) return
						let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedIndex); //找出当前选中行
						//如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
						if (findRow && this.selectedRow.length === 1) {
							refsElTable.toggleRowSelection(this.settleDataList[this.selectedIndex], false);
							return;
						}
						refsElTable.clearSelection();
						refsElTable.toggleRowSelection(this.settleDataList[this.selectedIndex]); // 把现在当前行勾选
						this.handleClick(this.settleDataList[this.selectedIndex])
					})
				} else if (e.keyCode == 38) { // 上键
					e.preventDefault();
					let refsElTable = this.$refs.moviesTable
					this.$nextTick(() => {
						if (this.selectedRow.length == 0) { // 当前没有选中行，则直接选中第一个
							this.selectedIndex = 0
						} else if (this.selectedIndex == 0) { // 如果选中的是第一行了，那么下一行选中的是最后一行
							this.selectedIndex = this.settleDataList.length - 1
						} else { // 正常递减
							this.selectedIndex--
						}
						if (!refsElTable) return
						let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedIndex); //找出当前选中行
						//如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
						if (findRow && this.selectedRow.length === 1) {
							refsElTable.toggleRowSelection(this.settleDataList[this.selectedIndex], false);
							return;
						}
						refsElTable.clearSelection();
						refsElTable.toggleRowSelection(this.settleDataList[this.selectedIndex]); // 把现在当前行勾选
						this.handleClick(this.settleDataList[this.selectedIndex])
					})
				} else if (e.keyCode == 13) {
					this.handleSelectClick(this.settleDataList[this.selectedIndex])
				}

			},
			// 表格方法
			rowClassName({
				row,
				rowIndex
			}) {
				let rowName = "",
					findRow = this.selectedRow.find(c => c.rowIndex === row.rowIndex);
				if (findRow) {
					rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
				}
				return rowName; //也可以再加上其他类名 如果有需求的话
			},
			rowStyle({
				row,
				rowIndex
			}) {
				Object.defineProperty(row, "rowIndex", { // 给每行添加不可枚举属性rowIndex来标识当前行
					value: rowIndex,
					writable: true,
					enumerable: false
				});
				let rowBackground = {}
                if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
                return  rowBackground
			},
			clickEvent(row, column, event, params) {
				let refsElTable = this.$refs.moviesTable; // 获取表格对象
				let findRow = {}
				this.selectedIndex = row.rowIndex;
				findRow = this.selectedRow.find(c => c.rowIndex == row.rowIndex); //找出当前选中行
				//如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
				if (findRow && this.selectedRow.length === 1) {
					refsElTable.toggleRowSelection(row, false);
					return;
				}
				refsElTable.clearSelection();
				refsElTable.toggleRowSelection(row);
				this.handleClick(row)
			},
			handleSelectionChange(rows) {
				this.selectedRow = rows; // 保存已选择行
			},

		},
	};
</script>
<style scoped>
	.el-pagination {
		padding: 20px 0px 5px;
	}
</style>